import { render, staticRenderFns } from "./field-authority.vue?vue&type=template&id=23dacf25&scoped=true&"
import script from "./field-authority.vue?vue&type=script&lang=js&"
export * from "./field-authority.vue?vue&type=script&lang=js&"
import style0 from "./field-authority.vue?vue&type=style&index=0&id=23dacf25&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dacf25",
  null
  
)

export default component.exports